export default "__VITE_ASSET__CdtaJCFP__"